import React from 'react';
import './style.css';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Tooltip,
  Cell,
  Legend
} from 'recharts';

const data = [
  { name: 'Amarelo Mostarda', value: 400 },
  { name: 'Vermelho', value: 300 },
  { name: 'Verde Escuro', value: 300 }
];

const COLORS = ['#d4a017', '#ff0000 ', '#155724'];

function PieChartComponent() {
  return (
    <div className="chart-item">
      <h2 className="section-title">Distribuição por Categoria</h2>
      <ResponsiveContainer width="100%" height={400}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={120}
            label
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export default PieChartComponent;
